import { vennTransform } from "@visactor/vlayouts";

import { isFunction } from "@visactor/vutils";

export const vennLayout = (data, op) => {
    const options = isFunction(op) ? op() : op, viewBox = options.getViewBox();
    return viewBox && (null == data ? void 0 : data.length) ? vennTransform(Object.assign({
        setField: options.setField,
        valueField: options.valueField
    }, viewBox), data) : [];
};
//# sourceMappingURL=venn.js.map
